module.exports = __webpack_public_path__ + "static/media/anti-reflex.9784593b.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/oakleyStealth/anti-reflex.png
// module id = 3506
// module chunks = 0